import React, { useEffect, useState } from "react";
import ApplicationInProgressList from "../../../../components/HRMS/RecruitmentTracker/ApplicationInProgress/ApplicationInProgressList";
import OfferAccepted from "../../../../components/HRMS/RecruitmentTracker/OfferAccepted/OfferAccepted";
import { CommonHeader } from "../../../../components/commons";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import {
  resetRecruitmentTrackerList,
  resetRecruitmentTrackerTotalCount,
} from "../../../../redux/hrms";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { setPersistApplicationInProgess, setPersistOfferAccepted } from "../../../../redux/masterData";
type TabsType = {
  name: string;
  label: string;
  display: boolean | undefined;
};
const tabs: TabsType[] = [
  {
    name: "Applications In Progress",
    label: "applications_In_Progress",
    display: false,
  },
  {
    name: "Offer Accepted",
    label: "offer_Accepted",
    display: false,
  },
];
type AppProps = {
  history?: any;
  dispatchResetRecruitmentTrackerTotalCount: () => void;
  dispatchResetRecruitmentTrackerList: () => void;
  fetching:boolean;
  dispatchSetPersistOfferAcceptedData:(data:any)=>void;
  dispatchSetPersistApplicationInProgressData: (data: any) => void;

};
const RecruitmentTracker = ({
  history,
  dispatchResetRecruitmentTrackerTotalCount,
  dispatchResetRecruitmentTrackerList,
  dispatchSetPersistOfferAcceptedData,
  dispatchSetPersistApplicationInProgressData,
  fetching
}: AppProps) => {
  const persistActivetab = history?.location?.state?.activeTab;

  const [activeComponent, setActiveComponent] = useState<any>();
  const [finalTab, setFinalTab] = useState(tabs);

  //====================User Management=============================
  const [isAddRecruitmentTrackerPresent, setIsAddRecruitmentTrackerPresent] =
    useMenuCheck();
  const [isGetRecruitmentTrackerPresent, setIsGetRecruitmentTrackerPresent] =
    useMenuCheck("list");
  const [
    isGetRecruitmentTrackerOfferAcceptedPresent,
    setIsGetRecruitmentTrackerOfferAcceptedPresent,
  ] = useMenuCheck("Offer");
  //=================================================================
  const [activeTab, setActiveTab] = useState(
    persistActivetab ? persistActivetab : tabs[0]?.label
  );
  useEffect(() => {
    setIsAddRecruitmentTrackerPresent("Add Recruitment Tracker", "menu");
    setIsGetRecruitmentTrackerPresent("Recruitment Tracker List", "menu");
    setIsGetRecruitmentTrackerOfferAcceptedPresent(
      "Recruitment Tracker Offer Accepted List",
      "menu"
    );
    dispatchResetRecruitmentTrackerTotalCount();
    dispatchResetRecruitmentTrackerList();
  }, []);

  useEffect(() => {
    if (
      isGetRecruitmentTrackerPresent &&
      !isGetRecruitmentTrackerOfferAcceptedPresent
    ) {
      setFinalTab([tabs[0]]);
      setActiveTab(tabs[0]?.label);
    } else if (
      isGetRecruitmentTrackerOfferAcceptedPresent &&
      !isGetRecruitmentTrackerPresent
    ) {
      setFinalTab([tabs[1]]);
      setActiveTab(tabs[1]?.label);
    } else if (
      !isGetRecruitmentTrackerPresent &&
      !isGetRecruitmentTrackerOfferAcceptedPresent
    ) {
      setFinalTab([]);
    } else {
      setFinalTab([...tabs]);
    }
  }, [
    isGetRecruitmentTrackerPresent,
    isGetRecruitmentTrackerOfferAcceptedPresent,
  ]);

  useEffect(() => {
    if (persistActivetab) {
      setActiveTab(persistActivetab);
    }
  }, [persistActivetab]);

  const handleTabChange = (tabs: string) => {
    dispatchResetRecruitmentTrackerTotalCount();
    dispatchSetPersistOfferAcceptedData({
      data: [],
      offset: 0,
      scrollLeft: null,
      scrollTop: null,
      searchText: "",
    })
    dispatchSetPersistApplicationInProgressData({
      data: [],
      offset: 0,
      scrollLeft: null,
      scrollTop: null,
      searchText: "",
    });
    dispatchResetRecruitmentTrackerList();
    delete history?.location?.state?.isPersist;
    delete history?.location?.state?.multiSelectData;
    delete history?.location?.state?.sortBy;
    delete history?.location?.state?.searchTerm;
    delete history?.location?.state?.offerSortBy;
    delete history?.location?.state?.offerSearchTerm;
    delete history?.location?.state?.offerMultiSelectData;
    setActiveTab(tabs);
  
  };

  const renderTabs = () => {
    const finalTabs = finalTab?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className={tab.display ? "tab-style mr-4 pointer" : "pointer"}
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 16px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "16px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTabs;
  };

  const activeTabRender = () => {
    switch (activeTab) {
      case "applications_In_Progress":
        return (
          <ApplicationInProgressList activeTab={activeTab} history={history} />
        );
      case "offer_Accepted":
        return <OfferAccepted activeTab={activeTab} history={history} />;

      default:
        return (
          <ApplicationInProgressList activeTab={activeTab} history={history} />
        );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="Recruitment Tracker" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
            <div>
              <div className="d-flex flex-row justify-content-end">
                {activeTab == "applications_In_Progress" &&
                isAddRecruitmentTrackerPresent ? (
                  <button
                    style={{ fontSize: "14px", padding: "9px" }}
                    className="btn btn-primary"
                    onClick={() =>
                      history.push({
                        pathname: `/hrms/recruitment-module/recruitment-tracker/add`,
                        state: activeTab,
                      })
                    }
                  >
                    {activeTab == "applications_In_Progress" ? (
                      <span>+ Add New Candidate</span>
                    ) : (
                      ""
                    )}
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeTabRender()}
        </div>
      </div>
    </>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.hrms.fetching,


});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetRecruitmentTrackerTotalCount: () =>
    dispatch(resetRecruitmentTrackerTotalCount()),
  dispatchResetRecruitmentTrackerList: () =>
    dispatch(resetRecruitmentTrackerList()),
    dispatchSetPersistOfferAcceptedData: (data: any) =>
      dispatch(setPersistOfferAccepted(data)),
      dispatchSetPersistApplicationInProgressData: (data: any) =>
        dispatch(setPersistApplicationInProgess(data)),
});

export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(RecruitmentTracker);
